import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import {
  FooterSection,
  Title,
  Extra,
  Para,
  Large,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  const history = useHistory();

return (
  <>
    <FooterSection>
      <Container>
        <Row justify="space-between" align="top">
          <Col lg={4} md={4} sm={12} xs={12}>
              <SvgIcon src="logoDlk.png" width="150px" height="150px" />
          </Col>
          <Col lg={5} md={5} sm={12} xs={12}>
            <Title>{t("Sobre Nosotros")}</Title>
            <Large
              as="a"
              href="#services"
              onClick={e => {
                e.preventDefault();
                history.push("/");
                setTimeout(() => {
                  const section = document.getElementById('services');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              }}
            >
              {t("Servicios Destacados")}
            </Large>
          </Col>
          <Col lg={5} md={5} sm={12} xs={12}>
            <Title>{t("Secciones")}</Title>
            <Large
              as="a"
              href="/"
              onClick={e => {
                e.preventDefault();
                history.push("/");
              }}
            >
              {t("Inicio")}
            </Large>
            <Large
              as="a"
              href="#certification"
              onClick={e => {
                e.preventDefault();
                history.push("/");
                setTimeout(() => {
                  const section = document.querySelector('.certification__section');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              }}
            >
              {t("Partners y Certificaciones")}
            </Large>
            <Large
              as="a"
              href="#carrousel"
              onClick={e => {
                e.preventDefault();
                history.push("/");
                setTimeout(() => {
                  const section = document.getElementById('carrousel');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              }}
            >
              {t("Clientes / Empresas")}
            </Large>
            <Large
              as="a"
              href="/aws"
              onClick={e => {
                e.preventDefault();
                history.push("/aws");
              }}
            >
              {t("AWS")}
            </Large>
          </Col>
          <Col lg={5} md={5} sm={12} xs={12}>
            <Title>{t("Formulario")}</Title>
            <Large
              as="a"
              href="#contact"
              onClick={e => {
                e.preventDefault();
                history.push("/");
                setTimeout(() => {
                  const section = document.getElementById('contact');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              }}
            >
              {t("Consultar")}
            </Large>
          </Col>
          <Col lg={5} md={5} sm={12} xs={12}>
            <Title>{t("Búscanos")}</Title>
              <Large
                as="a" 
                href="https://maps.google.com/?q=Av.+Providencia+1208,+Oficina+1406,+7500571+Providencia,+Región+Metropolitana"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginBottom: '10px', cursor: 'pointer', display: 'block' }}
              >
                Av. Providencia 1208, Oficina 1406, 7500571 Providencia, Región Metropolitana
              </Large>
              <Large 
                as="a" 
                href="tel:+56233403796"
              >
              +56 2 3340 3796
            </Large>
          </Col>
        </Row>
      </Container>
    </FooterSection>
    <Extra>
      <Container>
        <Row justify="center">
          <Col span={24} style={{ textAlign: 'center' }}>
            <Para>Copyright © 2025 Decalink</Para>
          </Col>
        </Row>
      </Container>
    </Extra>
  </>
);
};

export default withTranslation()(Footer);